import { WizardStepComponent } from 'mbs-ui-kit';
import HostInfo from 'mbs-ui-shared@models/rmm/HostInfo';
import {
  CompanyFromRegGroupTask,
  ComputerFromRegGroupTask,
  GroupTask,
  GroupTaskOsTypes,
  RunTypes,
  ScheduledDataFromGroupTask
} from '../rmmGroupTasks/model';

export interface WizardGroupAction {
  id?: string;
  name: string;
  osType: GroupTaskOsTypes;
  actionSelectCommand: WindowsAvailableActions | LinuxAvailableActions | MacAvailableActions;

  applyTo: SelectedEntities;

  groupActionCommand: GroupActionsCommands;
  parameters: Partial<GroupTask>;

  schedule: ScheduleState;
}

export enum GroupTaskOsTypeNames {
  Windows = 'windows',
  MacOS = 'macos',
  Linux = 'linux'
}

// Result of the Schedule step in wizard
export interface ScheduleState {
  runType: RunTypes;
  scheduleType: number | string;
  scheduleData: ScheduledDataFromGroupTask;
  scheduleDesc?: string;
}

// Result of the ApplyTo step in wizard
export interface SelectedEntities {
  computers: ComputerFromRegGroupTask[];
  companies: CompanyFromRegGroupTask[];
  computerTags: number[];
  allCompanies: boolean;
}

export interface Step {
  id: GroupActionStepsList;
  title: string;
  valid: boolean;
  canNext: boolean;
  ref?: WizardStepComponent;
}

export enum GroupActionStepsList {
  ACTION = 'action',
  COMPUTER = 'computers',
  SCHEDULE = 'schedule',
  RUN = 'run',
  SUMMARY = 'summary',
  RESULT = 'result'
}

export interface StepAnnotation {
  [key: string]: Step['title'];
}

export type ExecutionStatus = 'executing' | 'ok' | 'fail' | 'unknown';

// Entire command naming
export enum GroupActionsCommands {
  POWERSHELL = 'powerSHell',
  BASH = 'bash',
  FILE_SCRIPT = 'execScript',
  SCRIPT_LIBRARY = 'scriptLibrary',
  SCRIPT_LIBRARY_BASH = 'scriptLibraryBash',
  // UNINSTALL_PATCH = 'uninstallPatch',
  INSTALL_SOFTWARE = 'installProductSimple',
  UNINSTALL_SOFTWARE = 'uninstallProduct',
  INSTALL_PATCH = 'downloadAndInstall',
  UPDATE_POLICY = 'updatePolicy',
  WIN_GET = 'winGet',
  BREW = 'brew',
  LINUX = 'linux'
}

export enum WindowsAvailableActions {
  PowerShell = GroupActionsCommands.POWERSHELL,
  Uninstall = GroupActionsCommands.UNINSTALL_SOFTWARE,
  WindowsUpdates = GroupActionsCommands.INSTALL_PATCH,
  UpdatePolicy = GroupActionsCommands.UPDATE_POLICY,
  InstallAndUpdate = GroupActionsCommands.WIN_GET
}

export enum LinuxAvailableActions {
  Bash = GroupActionsCommands.BASH,
  Linux = GroupActionsCommands.LINUX
}

export enum MacAvailableActions {
  Bash = GroupActionsCommands.BASH,
  Brew = GroupActionsCommands.BREW
}

export type GAComputer = HostInfo & { id?: string; hid?: string };

// utility
export enum ScriptModeSelectTypes {
  fromScript,
  fromScriptLibrary,
  fromFile
}

export enum InstallSofwareSelectionTypes {
  usingPackageManager,
  usingLink
}

export enum TimeMeasureValues {
  minutes,
  hours
}

export const DEFAULT_RMM_GROUP_TASK_TIMEOUT = '5';
